import { render, staticRenderFns } from "./ongoing-maintenances-column.vue?vue&type=template&id=067aca59&"
import script from "./ongoing-maintenances-column.vue?vue&type=script&lang=js&"
export * from "./ongoing-maintenances-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports